var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error-content"},[_c('div',{staticClass:"error-content__title"},[_vm._v(" "+_vm._s(_vm.$t('Errors.ServerError'))+" ")]),_c('div',{staticClass:"ml-4 pt-4 pb-4 text-left h4-headline opacity-7"},[_c('div',[_vm._v(_vm._s(_vm.$t('Errors.ServerErrorText.0')))]),_c('div',[_vm._v(_vm._s(_vm.$t('Errors.ServerErrorText.1')))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }